var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReplay = function SvgIconReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3.33329V0.666626L4.6665 3.99996L7.99984 7.33329V4.66663C10.2065 4.66663 11.9998 6.45996 11.9998 8.66663C11.9998 10.8733 10.2065 12.6666 7.99984 12.6666C5.79317 12.6666 3.99984 10.8733 3.99984 8.66663H2.6665C2.6665 11.6133 5.05317 14 7.99984 14C10.9465 14 13.3332 11.6133 13.3332 8.66663C13.3332 5.71996 10.9465 3.33329 7.99984 3.33329Z",
    fill: "black"
  })));
};
export default SvgIconReplay;